import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { DockerImage, DockerImageListResponse, DockerImageQueryParams, UpdateDockerImage } from '@frontend/version/types';

export class DockerImageClient extends APIClient {
    public static readonly endpoint = '/version-api/v1';

    public static async fetchDockerImages(queryParams?: ApiQueryParams<DockerImageQueryParams>): Promise<DockerImageListResponse> {
        return await this.apiPaginated<DockerImageListResponse, DockerImageQueryParams>(`${this.endpoint}/docker-images`, queryParams);
    }

    public static async fetchReleases(queryParams?: ApiQueryParams<DockerImageQueryParams>): Promise<DockerImageListResponse> {
        return await this.apiPaginated<DockerImageListResponse, DockerImageQueryParams>(`${this.endpoint}/releases`, queryParams);
    }

    public static async fetchDockerImage(imageId: string): Promise<DockerImage> {
        const response = await this.fetch(`${this.endpoint}/docker-images/${imageId}`);
        return await this.handleResponse<DockerImage>(response);
    }

    public static async patchDockerImage(imageId: string, data: UpdateDockerImage): Promise<DockerImage> {
        const response = await this.patch(`${this.endpoint}/docker-images/${imageId}`, data);
        return await this.handleResponse<DockerImage>(response);
    }
}
